import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({

  plugins: [createPersistedState()],

  state:{
    memberToken:null
  },

  mutations: {
    setMemberToken(state, resp) {
      state.memberToken = resp.memberToken
    },

    trashMemberToken(state) {
      state.memberToken=null
    },
  },

  getters : {
    memberToken:state=>state.memberToken,
  },

  actions: {

    memberLogin({commit},member) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_API_URL + '/member/validate-login',
          data: member,
          method: 'POST',
        })
            .then(resp => {
              const memberToken = resp.data.token
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + memberToken
              commit('setMemberToken', {memberToken})
              resolve(resp)
            })
            .catch(err => {
              reject(err)
            })
      })
    },

    memberLogout({ commit }) {
      return new Promise((resolve, reject) => {

        axios({
          url: process.env.VUE_APP_API_URL + '/member/logout',
          method: 'POST'
        });

        commit('trashMemberToken')

        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
  },

  /* Enable strict mode in development to get a warning
     when mutating state outside of a mutation.
     https://vuex.vuejs.org/guide/strict.html
   */
  strict: process.env.NODE_ENV !== 'production',
})

export default store

